import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-values-boss',
  slug: 'boss',
  title: 'Format a shopping receipt',
  type: 'boss',
  estSeconds: 900,
  contentVersion: 1,
});
